import { authHeader, history } from "../_helpers";
import config from "../config";

export const TwoPlusService = {
  get2lusArophiCount,
  get2lusNewArophiPoliceStationCount,
  get2lusNewArophiCount,
  get2PlusNewArophiList,
  get2plusNewArophiListPoliceStation,
  get2lusArophiListCount,
  get2lusArophiListPoliceStationCount,
  getCriminalsByCityId,
  getHistorySheeterCount,
  getHistorySheeterCountPS,
  getHistorySheeterList,
  getHistorySheeterListPS,
  getCriminalHistoryDetails,
  get2lusArophiByUserIdCount,
  get2plusNewArophiByidList,
  get2lusArophiListByIdCount,
  getHistorySheeterByIdCount,
  getHistorySheeterByIdList,
  getPlus2ArophiListByRole,
  get2lusArophiListCountByRole,
  getHistorySheeterListByRole,
  get2lusNewArophiCountByRole,
  get2lusArophiCountByRole,
  getHistorySheeterCountByRole,
  get2lusNewListArophiCount,
  get2lusNewListArophiCountByRole,
  get2PlusNewAropiPostBharaliCount,
  get2PlusNewAropiPostBharaliList,
  get2lusNewListPostBharaliCount,
  get2lusArophiPostBharaliList,
  get2PlusNewAropiPostBharaliListByRole,
  get2PlusNewAropiPostBharaliCountByRole,
  get2lusNewListPostBharaliCountByRole,
  get2lusArophiPostBharaliListByRole,
  get2plusNewArophiPreventiveActionList,
  get2plusNewArophiPreventiveActionPoliceStationList,
};
const baseUrl = config.apiGateway.baseUrl;
// const baseUrl = "https://www.criminalmis.in/api";

const cityPath = (cityId) =>
  Array.isArray(cityId) ? cityId.join(",") : cityId;

function get2lusArophiCount(startDate, endDate, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusArophiCount/${startDate}/${endDate}/${cityPath(cityId)}`,
    requestOptions
  );
}
function get2lusNewArophiPoliceStationCount(startDate, endDate, id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusArophiListPoliceStationCount/${startDate}/${endDate}/${id}`,
    requestOptions
  );
}

function get2lusNewArophiCount(startDate, endDate, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusNewArophiCount/${startDate}/${endDate}/${cityPath(cityId)}`,
    requestOptions
  );
}

function get2PlusNewArophiList(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/get2plusNewArophiList/`, requestOptions);
}

function get2plusNewArophiListPoliceStation(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(
    `${baseUrl}/criminal/get2plusNewArophiListPoliceStation/`,
    requestOptions
  );
}

function get2lusArophiListCount(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(`${baseUrl}/criminal/get2lusArophiListCount/`, requestOptions);
}

function get2lusArophiListPoliceStationCount(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusArophiListPoliceStationCount/`,
    requestOptions
  );
}
function getCriminalsByCityId(
  startDate,
  endDate,
  cityId,
  districtName,
  date_order
) {
  console.log("districtName", districtName);
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/get2plusDistrictName/${startDate}/${endDate}/${cityId}/${districtName}/${date_order}`,
    requestOptions
  );
}

function getHistorySheeterCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getHistorySheeterCount`, requestOptions);
}

function getHistorySheeterCountPS(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getHistorySheeterCount`, requestOptions);
}

function getHistorySheeterList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getHistorySheeterList`, requestOptions);
}

function getHistorySheeterListPS(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getHistorySheeterPoliceStationList`,
    requestOptions
  );
}

function getCriminalHistoryDetails(cityId, districtName) {
  console.log("districtName", districtName);
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/getHistorySheeterdistrictName/${cityId}/${districtName}`,
    requestOptions
  );
}
function get2lusArophiByUserIdCount(startDate, endDate, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusArophiByUserIdCount/${startDate}/${endDate}/${cityId}`,
    requestOptions
  );
}
function get2plusNewArophiByidList(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(
    `${baseUrl}/criminal/get2plusNewArophiByidList/`,
    requestOptions
  );
}

function get2lusArophiListByIdCount(data) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(data),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusArophiListByIdCount/`,
    requestOptions
  );
}
function getHistorySheeterByIdCount(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getHistorySheeterByIdCount`,
    requestOptions
  );
}
function getHistorySheeterByIdList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getHistorySheeterByIdList`, requestOptions);
}

function getPlus2ArophiListByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/getPlus2ArophiListByRole/`, requestOptions);
}
function get2lusArophiListCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusArophiListCountByRole/`,
    requestOptions
  );
}
function getHistorySheeterListByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getHistorySheeterListByRole/`,
    requestOptions
  );
}
function get2lusNewArophiCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusNewArophiCountByRole/`,
    requestOptions
  );
}
function get2lusArophiCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(`${baseUrl}/criminal/get2lusArophiCountByRole/`, requestOptions);
}
function getHistorySheeterCountByRole(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/getHistorySheeterCountByRole/`,
    requestOptions
  );
}
function get2lusNewListArophiCount(startDate, endDate, cityId) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusNewListArophiCount/${startDate}/${endDate}/${cityPath(cityId)}`,
    requestOptions
  );
}
function get2lusNewListArophiCountByRole(values){
   const requestOptions = {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
       ...authHeader(),
     },
     body: JSON.stringify(values),
   };

   return fetch(
     `${baseUrl}/criminal/get2lusNewListArophiCountByRole/`,
     requestOptions
   );
}
function get2PlusNewAropiPostBharaliList(values){
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get2PlusNewAropiPostBharaliList/`,
    requestOptions
  ); 
}
function get2PlusNewAropiPostBharaliCount(values){
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get2PlusNewAropiPostBharaliCount/`,
    requestOptions
  ); 
}
function get2lusNewListPostBharaliCount(values){
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusNewListPostBharaliCount/`,
    requestOptions
  ); 
}
function get2lusArophiPostBharaliList(values){
   const requestOptions = {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
       ...authHeader(),
     },
     body: JSON.stringify(values),
   };

   return fetch(
     `${baseUrl}/criminal/get2lusArophiPostBharaliList/`,
     requestOptions
   ); 
}
function get2PlusNewAropiPostBharaliListByRole(values){
   const requestOptions = {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
       ...authHeader(),
     },
     body: JSON.stringify(values),
   };

   return fetch(
     `${baseUrl}/criminal/get2PlusNewAropiPostBharaliListByRole/`,
     requestOptions
   ); 
}
function get2PlusNewAropiPostBharaliCountByRole(values){
     const requestOptions = {
       method: "POST",
       headers: {
         "Content-Type": "application/json",
         ...authHeader(),
       },
       body: JSON.stringify(values),
     };

     return fetch(
       `${baseUrl}/criminal/get2PlusNewAropiPostBharaliCountByRole/`,
       requestOptions
     ); 
}
function get2lusNewListPostBharaliCountByRole(values){
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusNewListPostBharaliCountByRole/`,
    requestOptions
  ); 
}
function get2lusArophiPostBharaliListByRole(values){
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get2lusArophiPostBharaliListByRole/`,
    requestOptions
  ); 
}

function get2plusNewArophiPreventiveActionList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get2plusNewArophiPreventiveActionList/`,
    requestOptions,
  );
}

function get2plusNewArophiPreventiveActionPoliceStationList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };

  return fetch(
    `${baseUrl}/criminal/get2plusNewArophiPreventiveActionPoliceStationList/`,
    requestOptions,
  );
}